export const BAR = {
  ink: '#2b2a28',
  copper: '#d97a1f',
  copperBright: '#e8922e',
  cream: '#faf9f6',
  paperWarm: '#f5f0e8',
  muted: '#6b6760',
  border: 'rgba(43, 42, 40, 0.12)',
  white: '#ffffff',
} as const;

export const displayFont =
  '"Cormorant Garamond", "Cormorant", Georgia, "Times New Roman", serif';

export const eyebrowSx = {
  fontSize: '0.72rem',
  letterSpacing: '0.32em',
  textTransform: 'uppercase',
  color: BAR.copperBright,
  fontWeight: 500,
} as const;

/** Escapa o padding do Layout e ocupa toda a largura da viewport */
export const fullBleedSx = {
  width: '100vw',
  maxWidth: '100vw',
  position: 'relative',
  left: '50%',
  right: '50%',
  marginLeft: '-50vw',
  marginRight: '-50vw',
} as const;

export const heroOverlaySx = {
  position: 'absolute',
  inset: 0,
  background: {
    xs: `linear-gradient(
      to top,
      rgba(43, 42, 40, 0.94) 0%,
      rgba(43, 42, 40, 0.82) 38%,
      rgba(43, 42, 40, 0.45) 62%,
      rgba(43, 42, 40, 0.15) 82%,
      transparent 100%
    )`,
    md: `linear-gradient(
      to right,
      rgba(43, 42, 40, 0.9) 0%,
      rgba(43, 42, 40, 0.72) 42%,
      rgba(43, 42, 40, 0.35) 68%,
      transparent 100%
    )`,
  },
} as const;
